// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tree-container{\ndisplay: flex;\nflex-direction: column;\n}\n\n.tree-name{\ntext-align: left;\nposition: relative;\n\n}", ""]);
// Exports
module.exports = exports;
